import api from './api';

/**
 * Cross-app SSO handoff into the Corporate Legal Suite.
 *
 * The corporate app (`corporate-web`) has NO login of its own — every session
 * originates here. We ask our backend for a single-use, short-lived handoff
 * *nonce* (NOT a credential), then full-navigate to the corporate app's `/sso`
 * route carrying the nonce in the URL *fragment* (never sent to a server / not
 * logged). The corporate backend exchanges the nonce for a fresh Firebase custom
 * token server-side, so no long-lived credential ever touches a URL.
 *
 * Throws if the corporate URL isn't configured or the mint fails, so callers can
 * surface an error instead of silently navigating nowhere.
 */
export async function launchCorporateSuite(): Promise<void> {
  const base = process.env.REACT_APP_CORPORATE_WEB_URL;
  if (!base) {
    throw new Error('Corporate Suite URL is not configured.');
  }

  const { data } = await api.post<{ nonce: string }>('/auth/corporate-handoff');
  const nonce = data?.nonce;
  if (!nonce) {
    throw new Error('Could not start the corporate session handoff.');
  }

  const url = `${base.replace(/\/$/, '')}/sso#nonce=${encodeURIComponent(nonce)}`;
  window.location.href = url;
}
